/**
 * @file 号码标记
 * @author wangzhuang
 */

import {rcAjax} from '../util';
import {
    VERIFY_MSG_UPDATE,
    GET_VERIFY_TYPE,
    VERIFY_MSG_CLEAN
} from './ActionTypes';

export function fetchMsgType(dispatch, params) {
    return rcAjax('POST', '/api/v1/auth/change', {}, params, data => {
        dispatch({type: GET_VERIFY_TYPE, data: data.data});
    });
}

export function updateVerifyMsg(dispatch, obj) {
    dispatch({
        type: VERIFY_MSG_UPDATE,
        data: obj
    });
    return obj;
}

export function cleanVerifyMsg(dispatch) {
    dispatch({
        type: VERIFY_MSG_CLEAN
    });
}